import React from "react";
import {
  AppBar,
  Box,
  Button,
  Menu,
  MenuItem,
  Toolbar,
} from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import { useTranslation } from "react-i18next";
import { IReceiptToolbarProps } from "./types";

const ReceiptToolbar: React.FC<IReceiptToolbarProps> = ({
  handleHelpClick,
}) => {
  const { t, i18n } = useTranslation("paymentPage");
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const lang = i18n.language === "zh" ? "zh" : "en";

  const handleLangMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLangMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLangChange = (selectedLang: string) => {
    i18n.changeLanguage(selectedLang);
    handleLangMenuClose();
  };

  return (
    <>
      <AppBar
        position="fixed"
        color="default"
        elevation={1}
        sx={{ zIndex: 1201 }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <img
              src="/dash-logo.png"
              alt="Dash Logo"
              style={{ height: 20, marginRight: 8 }}
            />
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Button
              color="primary"
              sx={{
                fontWeight: 500,
                textTransform: "none",
                minWidth: 0,
                px: 1,
              }}
              onClick={handleLangMenuOpen}
              startIcon={<LanguageIcon />}
            >
              {lang === "en" ? "EN" : "ZH"}
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleLangMenuClose}
            >
              <MenuItem
                selected={lang === "en"}
                onClick={() => handleLangChange("en")}
              >
                EN
              </MenuItem>
              <MenuItem
                selected={lang === "zh"}
                onClick={() => handleLangChange("zh")}
              >
                ZH
              </MenuItem>
            </Menu>
            <Button
              color="primary"
              sx={{ fontWeight: 500, textTransform: "none" }}
              onClick={handleHelpClick}
            >
              {t("commonSupportButton")}
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
      <Toolbar />
    </>
  );
};

export default ReceiptToolbar;
